import React from 'react';
import { Clock } from 'lucide-react';
/*
  PLACEHOLDER: replace the text below with a TRUTHFUL reason to act now
  (e.g. a genuinely limited finish, a real first-order bonus, or an honest
  shipping/stock note). Remove this component entirely if there is no honest
  urgency mechanism — do not invent scarcity.
*/
export function UrgencyBadge() {
  return <div className="inline-flex items-center gap-2 rounded-full bg-amber-50 border border-amber-200 px-4 py-2 text-sm" data-id="element-142">
      <Clock size={16} className="text-amber-600" data-id="element-143" />
      <span className="font-medium text-amber-900" data-id="element-144">
        {/* PLACEHOLDER urgency copy */}
        Free breathwork course included with first orders this month
      </span>
    </div>;
}